import {NatGetCondominiumAuthoritySetting} from './NatGetCondominiumAuthoritySetting';
import {
    NatPutCondominiumAuthoritySetting,
    NatPutCondominiumAuthoritySettingParams
} from './NatPutCondominiumAuthoritySetting';

import Http from '../../../../network/Http'
import {Nullable} from '../../../../app/TypeHelpers';


export default class NatCondominiumAuthoritySettingRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // 物件権限設定一覧取得
    async getCondominiumAuthoritySetting(condominiumCd: Nullable<string>): Promise<NatGetCondominiumAuthoritySetting> {
        if (condominiumCd) {
            condominiumCd = encodeURIComponent(condominiumCd)
        }
        return await this.http.get(`/api/admin/condominiumAuthoritySetting?condominiumCd=` + condominiumCd);
    }

    // 物件権限設定一括更新
    async putCondominiumAuthoritySetting(requestParam: NatPutCondominiumAuthoritySettingParams):
        Promise<NatPutCondominiumAuthoritySetting> {
        return await this.http.put(`/api/admin/condominiumAuthoritySetting`, requestParam)
    }
}
